import { useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../../../../utils/firebase/firebase.utils.js';
import { selectUser } from '../../../../../store/user/user.selector.js';

// styles
import { HeaderFriendsPillContainer } from './HeaderFriendsPill.styles.js';

// assets
import Group from '@mui/icons-material/Group';

// components
import HeaderBtn from '../header-btn/HeaderBtn';

export default function HeaderFriendsPill({ navigateTo }) {
  const user = useSelector(selectUser);
  const [friendsCount, setFriendsCount] = useState(null);
  const userUid = useMemo(() => user?.uid, [user]);

  const handleSnapshot = useCallback((snapshot) => {
    setFriendsCount(snapshot.size);
  }, []);

  useEffect(() => {
    if (!userUid) return;

    const friendsRef = collection(db, `users/${userUid}/friends`);
    const acceptedQuery = query(friendsRef, where('status', '==', 'accepted'));

    const unsubscribe = onSnapshot(
      acceptedQuery,
      handleSnapshot,
      () => {}
    );

    return () => unsubscribe();
  }, [userUid, handleSnapshot]);

  if (friendsCount === null) {
    return null;
  }

  return (
    <HeaderFriendsPillContainer to={navigateTo}>
      <HeaderBtn val={friendsCount}>
        <Group />
      </HeaderBtn>
    </HeaderFriendsPillContainer>
  );
}
